import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ReactTable from 'react-table';

import { fetchData, valuesSorter } from '../helpers';

class Table extends PureComponent {
  state = {
    data: [],
    isLoading: true,
  };

  fetch() {
    return fetchData().then(playersData => {
      this.setState({ isLoading: false, data: playersData });
    });
  }

  render() {
    const { activeColumns, columns } = this.props;

    const { data, isLoading } = this.state;

    const filteredColumns = columns.filter(
      column => activeColumns[column.id || column.accessor]
    );

    return (
      <div className="x-stat-table">
        <ReactTable
          data={data}
          columns={filteredColumns}
          resizable={false}
          loading={isLoading}
          onFetchData={() => this.fetch()}
          showPagination={false}
          defaultPageSize={28}
          className="-stripedsortt"
          defaultSortMethod={valuesSorter}
        />
      </div>
    );
  }
}

Table.propTypes = {
  /**
   * Columns statuses
   */
  activeColumns: PropTypes.object.isRequired,

  /**
   * Columns params
   */
  columns: PropTypes.array.isRequired,
};

export default Table;
